// $(function () {
// var
// $brandNav = $('.brandList__nav'),
// $anchor = $('.wrap'),
// barHeight = 50,
// timer = null,
// offsetTop = $brandNav.offset().top;
// $(window).on('scroll', function () {
// // もし「ページ最上部からスクロールした位置」までの距離がナビゲーションのある位置を越えたら
// if ($(window).scrollTop() + barHeight > offsetTop) {
// fixNav();
// } else {
// clearNavStyle();
// }
// });
// $(window).on('resize', function () {
// // リサイズが終わった時だけ処理する
// if (timer) clearTimeout(timer);
// timer = setTimeout(function () {
// clearNavStyle();
// fixNav();
// }, 200);
// });
// // ページの途中を読み込んでもスクロールイベントを強制的に発火させる
// $('body').trigger('scroll');
// function fixNav () {
// var navOffsetleft = $brandNav.offset().left;
// $brandNav.css({
// position: 'fixed',
// top: barHeight,
// left: navOffsetleft
// });
// }
// function clearNavStyle() {
// $brandNav.css({
// position: '',
// top: '',
// left: ''
// });
// }
// });
// $('.brandList__nav a').on('click', function (ev) {
// // aリンクの標準動作をキャンセル
// ev.preventDefault();
// var $target = null;
// var offsetTop = null;
// var barHeight = 50;
// // 対象要素それぞれに対して処理を行う
// $('.brandList__index').each(function (idx, el) {
// // ev.currentTargetはクリックされた要素
// // elは現在処理中の要素
// // $().text()はエレメントが内包するテキスト(例: <a>ここ<\\/a>)
// if ($(ev.currentTarget).text() === $(el).text())
// $target = $(el);
// });
// // 「ページ最上部から要素までの距離」からバーの高さを引く
// offsetTop = $target.offset().top - barHeight;
// // 250ミリ秒かけて指定の位置まで移動
// $('html, body').animate({scrollTop: offsetTop}, 250);
// });
"use strict";
'use strict';

/* jshint esnext: true */

/**
 * dropdown in dropdown
 ***********************/
new Vue({
  el: '#dropdown-newTopics',
  template: '#dropdown-newTopics-template',

  data: {
    settings: {
      urlPrefixesPath: "./data/newTopics-prefixes.json",
      jsonPath: './data/newTopics.json'
    },
    prefixed: [],
    raw: []
  },
  created: function created() {
    var _this = this;
    // get json file
    $.ajax({
      url: this.settings.jsonPath,
      dataType: 'json'
    }).done(function (data) {
      _this.raw = data.slice(0, 4);
    }).done(function () {
      setPrefix();
    });

    function setPrefix() {
      return $.ajax({
        url: _this.settings.urlPrefixesPath,
        dataType: 'json'
      }).done(function (data) {
        var currentHost = window.location.host;
        var urlPrefixes = data[currentHost];

        _this.prefixed = $.map(_this.raw, function (el) {
          var urlPattern = /^https?:\/\//i;
          if (!el.url.match(urlPattern)) {
            el.url = urlPrefixes.url_before + el.url + urlPrefixes.url_after;
          }

          return el;
        });
      });
    }
  }
});
'use strict';

/* jshint esnext: true */
/**
 * header
 ***********************/
new Vue({
  el: '#header',
  template: '#header-template',

  data: {
    settings: {
      urlPrefixesPath: "./data/header-prefixes.json",
      jsonPath: './data/header.json'
    },
    style: {},
    prefixied: [],
    picked: {},
    raw: []
  },

  created: function created() {
    var _this2 = this;

    var _this = this;
    // get json file
    $.ajax({
      url: this.settings.jsonPath,
      dataType: 'json'
    }).done(function (data) {
      _this2.raw = data;
    }).done(function () {
      setPrefix().done(function () {
        var order = getRandomInt(0, _this.raw.length - 1);
        _this.picked = _this.prefixied[order];

        var imgSrc = _this.picked.image;
        _this.style = {
          backgroundImage: 'url(' + imgSrc + ')'
        };
      });
    });

    // https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Math/random
    function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function setPrefix() {
      return $.ajax({
        url: _this.settings.urlPrefixesPath,
        dataType: 'json'
      }).done(function (data) {
        var currentHost = window.location.host;
        var urlPrefixes = data[currentHost];

        _this.prefixied = $.map(_this.raw, function (el) {
          var urlPattern = /^https?:\/\//i;
          if (!el.image.match(urlPattern)) {
            el.image = urlPrefixes.image_before + el.image + urlPrefixes.image_after;
          }

          if (!el.url.match(urlPattern)) {
            el.url = urlPrefixes.url_before + el.url + urlPrefixes.url_after;
          }

          if (el.subImage && !el.subImage.match(urlPattern)) {
            el.subImage = urlPrefixes.image_before + el.subImage + urlPrefixes.image_after;
          }

          return el;
        });
      });
    }
  }
});

/**
 * header-sub
 ***********************/
new Vue({
  el: '#header-sub',
  template: '#header-sub-template',

  data: {
    settings: {
      urlPrefixesPath: "./data/header-sub-prefixes.json",
      jsonPath: './data/header-sub.json'
    },
    prefixied: [],
    raw: []
  },

  created: function created() {
    var _this3 = this;

    var _this = this;
    // get json file
    $.ajax({
      url: this.settings.jsonPath,
      dataType: 'json'
    }).done(function (data) {
      _this3.raw = data.slice(0, 6);
    }).done(function () {
      setPrefix();
    });

    function setPrefix() {
      return $.ajax({
        url: _this.settings.urlPrefixesPath,
        dataType: 'json'
      }).done(function (data) {
        var currentHost = window.location.host;
        var urlPrefixes = data[currentHost];

        _this.prefixied = $.map(_this.raw, function (el) {
          var urlPattern = /^https?:\/\//i;
          if (!el.image.match(urlPattern)) {
            el.image = urlPrefixes.image_before + el.image + urlPrefixes.image_after;
          }

          return el;
        });
      });
    }
  }
});
'use strict';

/* jshint esnext: true */
/**
 * dropdown menu
 ***********************/
$(function () {
  $('.js-dropdownMenu__item').hover(function (ev) {
    // mouseenter
    var $this = $(ev.currentTarget),
        dataType = $this.data('type');

    $this.addClass('js-active');

    $('.js-dropdownMenu__panel').each(function (idx, el) {
      var $el = $(el);

      if ($el.data('type') !== dataType) return;

      $el.css({
        display: 'block'
      });
    });
  }, function (ev) {
    // mouseleave
    var $this = $(ev.currentTarget),
        dataType = $this.data('type');

    $this.removeClass('js-active');

    $('.js-dropdownMenu__panel').each(function (idx, el) {
      var $el = $(el);

      if ($el.data('type') !== dataType) return;

      $el.css({
        display: ''
      });
    });
  }); // $('.js-dropdownMenu__item').hover()

  $('.js-dropdownMenu__panel').hover(function (ev) {
    // mouseenter
    var $this = $(ev.currentTarget),
        dataType = $this.data('type');

    $this.css({ display: 'block' });

    $('.js-dropdownMenu__item').each(function (idx, el) {
      var $el = $(el);

      if ($el.data('type') !== dataType) return;

      $el.addClass('js-active');
    });
  }, function (ev) {
    // mouseleave
    var $this = $(ev.currentTarget),
        dataType = $this.data('type');

    $this.css({ display: '' });

    $('.js-dropdownMenu__item').each(function (idx, el) {
      var $el = $(el);

      if ($el.data('type') !== dataType) return;

      $el.removeClass('js-active');
    });
  }); // $('.js-dropdownMenu__panel').hover()
});
'use strict';

/* jshint esnext: true */
/**
 * scroll top
 ***********************/
$(function () {
  $('.js-scrollTop').on('touchstart click', function () {
    $('html, body').animate({ scrollTop: 0 }, 500);

    return false;
  });
});
'use strict';

/* jshint esnext: true */
/**
 * newArrival
 ***********************/
new Vue({
  el: '#newArrival',
  template: '#newArrival-template',

  data: {
    settings: {
      sliceParPc: 12,
      sliceParMobile: 2,
      breakpoint: 992,
      urlPrefixesPath: "./data/new-arrival-prefixes.json",
      jsonPath: './data/new-arrival.json'
    },
    slicePar: null,
    slick: null,
    isMobile: null,
    prefixied: [],
    raw: []
  },

  computed: {
    // rawを[[],[],[]]の形に整形
    arranged: function arranged() {
      var _this2 = this;

      var dist = [[]];

      this.prefixied.forEach(function (el, idx) {
        var tail = dist.length - 1;

        dist[tail].push(el);

        // not last raw element
        if (_this2.prefixied.length - 1 === idx) return;
        // slicePar full
        if (dist[tail].length === _this2.slicePar) dist.push([]);
      });

      return dist;
    }
  },

  methods: {
    handleResize: function handleResize() {
      // 1
      this.isMobile = this.getIsMobile();
      // 2
      this.slicePar = this.getSlicePar();
    },
    getSlicePar: function getSlicePar() {
      if (this.isMobile) return this.settings.sliceParMobile;
      return this.settings.sliceParPc;
    },
    getIsMobile: function getIsMobile() {
      if (window.innerWidth < this.settings.breakpoint) return true;
      return false;
    },
    initJquery: function initJquery() {
      if (this.slick) $(this.slick).slick('slickRemove');

      this.slick = $('#newArrivalCarousel').slick({
        mobileFirst: true,
        slidesToShow: 1,
        dots: true,
        autoplay: false,
        arrows: false,
        responsive: [{
          breakpoint: this.settings.breakpoint,
          settings: {
            fade: true,
            arrows: true,
            autoplaySpeed: 3000
          }
        }]
      });
    }
  },

  created: function created() {
    var _this3 = this;

    var _this = this;
    // get json file
    $.ajax({
      url: this.settings.jsonPath,
      dataType: 'json'
    }).done(function (data) {
      _this3.raw = data.slice(0, 12 * 3);
    }).done(function () {
      setPrefix();
    });

    function setPrefix() {
      $.ajax({
        url: _this.settings.urlPrefixesPath,
        dataType: 'json'
      }).done(function (data) {
        var currentHost = window.location.host;
        var urlPrefixes = data[currentHost];

        _this.prefixied = $.map(_this.raw, function (el) {
          el.image = urlPrefixes.image_before + el.image + urlPrefixes.image_after;
          el.number = urlPrefixes.number_before + el.number + urlPrefixes.number_after;
          return el;
        });
      });
    }
  },

  ready: function ready() {
    var _this4 = this;

    // regist resize handler
    this.handleResize();
    window.addEventListener('resize', this.handleResize);

    // watch dom change
    this.$watch('arranged', function (newVal, oldVal) {
      // $nextTick to waiting for created dom
      _this4.$nextTick(function () {
        _this4.initJquery();
      });
    });
  }
});
/* jshint esnext: true */

/**
 * newTopics
 ***********************/
/**
new Vue({
  el: '#newTopics',
  template: '#newTopics-template',

  data: {
    settings: {
      urlPrefixesPath: "./data/newTopics-prefixes.json",
      jsonPath: './data/newTopics.json'
    },
    prefixed: [],
    raw: []
  },
  created: function() {
    let _this = this;
    // get json file
    $.ajax({
      url: this.settings.jsonPath,
      dataType: 'json'
    }).done(data => {
      _this.raw = data.slice(0, 4);
    }).done(() => {
      setPrefix();
    });

    function setPrefix() {
      return $.ajax({
        url: _this.settings.urlPrefixesPath,
        dataType: 'json'
      }).done(data => {
        let currentHost = window.location.host;
        let urlPrefixes = data[currentHost];

        _this.prefixed = $.map(_this.raw, el => {
          var urlPattern = /^https?:\/\//i;
          if (!el.url.match(urlPattern)) {
            el.url = urlPrefixes.url_before + el.url + urlPrefixes.url_after;
          }

          return el;
        });
      });
    }
  }
});
*/
"use strict";
'use strict';

/* jshint esnext: true */
/**
 * offcanvas menu
 ***********************/
$(function () {
  var $body = $('body'),
      $toggle = $('#offcanvasMenu-toggle'),
      $wrap = $('#offcanvasMenu-wrap'),
      $menu = $('#offcanvasMenu'),
      activeClass = 'js-offcanvas-active',
      transEnd = 'transitionend webkitTransitionEnd oTransitionEnd';

  $toggle.on('click', function (ev) {
    ev.preventDefault();

    $body.toggleClass(activeClass);
    $menu.css({ display: 'block' });
    return false;
  });

  $wrap.on('click', function (ev) {
    // only work $toggle is active
    if (!$body.hasClass(activeClass)) return;
    ev.preventDefault();

    $body.removeClass(activeClass);

    return false;
  });

  $wrap.on('touchmove', function (ev) {
    if (!$body.hasClass(activeClass)) return;
    ev.preventDefault();

    return false;
  });

  $wrap.on(transEnd, function () {
    if ($body.hasClass(activeClass)) return;
    $menu.css({ display: 'none' });
  });
});
/* jshint esnext: true */
/**
 * recommended Items
 ***********************/
/**
new Vue({
  el: '#recommendedItems',

  components: {
    'my-item': {
      props: ['item'],
      template: '#recommende-item-template'
    },
  },

  data: {
    settings: {
      sliceParPc: 6,
      sliceParMobile: 3,
      breakpoint: 992,
      urlPrefixesPath: "./data/recommendedItems-prefixes.json",
      jsonPaths: [
        './data/rocommended-items-1.json',
        './data/rocommended-items-2.json',
        './data/rocommended-items-3.json'
      ],
      slickHook: {
        mobile: [
          '#recommendedItemsCarousel--outer',
          '#recommendedItemsCarousel--bottom',
          '#recommendedItemsCarousel--item'
        ],
        pc: [
          '#recommendedItemsCarousel--pc'
        ]
      }
    },
    col: null,
    urlPrefixes: null,
    slick: [],
    isMobile: null,
    raw: [],
    prefixied: []
  },

  computed: {
    arranged: function() {
      let
        minLength = 0,
        i = 0,
        dist_pc = [],
        dist = [];

      // mobile (make column)
      //      0     0        1     1        2     2
      // [ [[...],[...]], [[...],[...]], [[...],[...]] ]
      this.prefixied.forEach(el => {
        let temp = [[]];

        el.forEach((nano, idx) => {
          let tail = temp.length - 1;

          temp[tail].push(nano);

          if (el.length - 1 === idx) return;
          if (temp[tail].length === this.col) temp.push([]);
        });

        dist.push(temp);
      });

      if (this.isMobile) return dist;

      // pc (make row)
      //      0     1     2        0     1     2
      // [ [[...],[...],[...]], [[...],[...],[...]],,,, ]
      dist.forEach(el => {
        if (minLength === 0 || minLength > el.length)
          minLength = el.length;
      });

      for (i; i < minLength; i++) {
        dist_pc.push((() => {
          let temp = [];

          dist.forEach(el => {
            temp.push(el[i]);
          });

          return temp;
        })());
      }

      return dist_pc;
    },
  },

  methods: {
    handleResize: function() {
      this.isMobile = this.getIsMobile();
      this.col = this.getCol();
    },
    getCol: function() {
      if (this.isMobile)
        return this.settings.sliceParMobile;
      return this.settings.sliceParPc;
    },
    getIsMobile: function() {
      if (window.innerWidth < this.settings.breakpoint)
        return true;
      return false;
    },
    initJquery: function() {
      let hooks = null;

      if (this.isMobile) {
        hooks = this.settings.slickHook.mobile;
      } else {
        hooks = this.settings.slickHook.pc;
      }

      this.slick.forEach(el => {
        if (el) $(el).slick('slickRemove');
      });

      hooks.forEach(el => {

        this.slick[this.slick.length] = $(el).slick({
          mobileFirst: true,
          slidesToShow: 1,
          dots: true,
          arrows: false,
          responsive: [
            {
              breakpoint: this.settings.breakpoint,
              settings: {
                fade: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 3000
              }
            }
          ]
        });

      });
    }
  },

  created: function() {
    let _this = this;

    // get json file
    let deffs = $.map(this.settings.jsonPaths, el => {
      return $.ajax({
        url: el,
        dataType: 'json'
      });
    });


    $.when.apply($, deffs).done((...args) => {
      let temp = [];
      args.forEach(el => temp.push(el[0]));
      _this.raw = temp;
    }).done(() => {
      setPrefix();
    });

    function setPrefix() {
      $.ajax({
        url: _this.settings.urlPrefixesPath,
        dataType: 'json'
      }).done(data => {
        let currentHost = window.location.host;
        let urlPrefixes = data[currentHost];

        _this.raw.forEach(el => {
          _this.prefixied.push($.map(el, nano => {
            nano.image = urlPrefixes.image + nano.image;
            nano.number = urlPrefixes.number_before + nano.number + urlPrefixes.number_after;
            return nano;
          }));
        });
      });
    }
  },

  ready: function() {
    // regist resize handler
    this.handleResize();
    window.addEventListener('resize', this.handleResize);

    // watch dom change
    this.$watch('arranged', (newVal, oldVal) => {
      // $nextTick to waiting for created dom
      this.$nextTick(() => {
        this.initJquery();
      });
    });
  }
});
*/
"use strict";
'use strict';

/* jshint esnext: true */
/**
 * dropdown category
 ***********************/
$(document).ready(function () {
  var active = 'js-active',
      $tabContents = $('.tab__contents > div'),
      $tabMenu = $('.tab__menu > li');

  $tabMenu.click(function () {
    var idx = $(this).data('index');

    $tabMenu.removeClass(active);
    $(this).addClass(active);

    $tabContents.removeClass(active).filter('[data-index="' + idx + '"]').addClass(active);
  });
});
'use strict';

/* jshint esnext: true */
/**
 * topNav position fixed
 ***********************/
$('#topNav').imagesLoaded().done(function (ev) {
  var $nav = $('#topNav'),
      $window = $(window),
      navHeight = null;

  $(window).on('scroll touchmove', function (ev) {
    if (navHeight) return;

    fix();
    return;
  });

  $(window).on('resize', function () {
    fix();
    return;
  });

  function fix() {
    navHeight = $nav.outerHeight();
    if ($window.width() >= 768) {
      $('body').css({ marginTop: '' });
      $nav.css({
        position: '',
        top: '',
        width: '',
        zIndex: ''
      });
      return;
    }
    $('body').css({ marginTop: navHeight });
    $nav.css({
      position: 'fixed',
      top: '0',
      width: '100%',
      zIndex: '999'
    });
  }
});
'use strict';

/* jshint esnext: true */
var fooo = new Vue({
  el: '#totalCoordinate',
  template: '#totalCoordinate-template',

  data: {
    settings: {
      jsonPath: './data/total-coordinate.json',
      urlPrefixesPath: './data/total-coordinate-prefixes.json'
    },
    raw: []
  },

  created: function created() {
    var _this = this;
    $.ajax({
      url: this.settings.jsonPath,
      dataType: 'json'
    }).done(function (data) {
      return _this.raw = data;
    }).done(function () {
      _this.raw = shuffleArray(_this.raw);
      _this.raw = _this.raw.slice(0, 1);

      setPrefix();
    });

    function shuffleArray(array) {
      var n = array.length,
          t,
          i;

      while (n) {
        i = Math.floor(Math.random() * n--);
        t = array[n];
        array[n] = array[i];
        array[i] = t;
      }

      return array;
    }

    function setPrefix() {
      $.ajax({
        url: _this.settings.urlPrefixesPath,
        dataType: 'json'
      }).done(function (data) {
        var currentHost = window.location.host;
        var urlPrefixes = data[currentHost];

        return $.map(_this.raw, function (el) {
          el.mainLink = urlPrefixes.number_before + el.mainLink + urlPrefixes.number_after;
          el.sub1Link = urlPrefixes.number_before + el.sub1Link + urlPrefixes.number_after;
          el.sub2Link = urlPrefixes.number_before + el.sub2Link + urlPrefixes.number_after;

          return el;
        });
      });
    }
  }
});

Vue.nextTick(function () {
  $('#totalCoordinateCarousel').slick({
    mobileFirst: true,
    slidesToShow: 1,
    dots: true,
    fade: true,
    autoplay: true,
    arrows: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        fade: false,
        arrows: true
      }
    }]
  });
});